import React from 'react'
import Container from 'react-bootstrap/Container'
import styled from 'styled-components'

const S = {
    Wrapper: styled(Container)`
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    `
}

const NotFound = () => (
    <S.Wrapper>
        <h1 style={{ margin: 'auto', fontWeight: 'bold' }}>404</h1>
    </S.Wrapper>
)

export default NotFound
